import React from "react";

type DownArrowIconProps = React.SVGProps<SVGSVGElement>;

export const DownArrowIcon = ({
  width = 20,
  height = 20,
  ...props
}: DownArrowIconProps) => (
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M12 4V20M6 14L12 20L18 14" stroke="#79808A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  
);

export default DownArrowIcon;
